/**
 * Team Block.
 * 
 */

/* global Alpine */

// const ScrollTrigger = require("gsap/dist/ScrollTrigger").ScrollTrigger;

function initTeamGrid() {
	console.log("TEAM: initTeamGrid()");

	let
		$teamBlockContent = $('.team-block__container'),	
		$teamGrid = $('.team-grid'),
		teamGridH = 0,
		hashCategory = window.location.hash.substr(1),
		inited = false;

	Alpine.data('teamBlockComponent', () => ({
		// Function init() grabs members and fades them in.
		init() {
			console.log("TEAM: init(): "+hashCategory);

			const myref = this;

			this.members = members;
			this.setChipsPerPage();
			this.fadeIn();
			inited = true;
		},

		// Function fadeIn() sets .team-block__container to invisible, then transitions to visible in .1s.
		fadeIn() {
			console.log("TEAM: fadeIn()");
			// Do not hide team if it has already been initialized / loaded and rendered once.
			if (inited) {
				this.visible = false;
			}
			setTimeout(() => {
				this.visible = true;
			}, 100);
		},
	
		// .team-block__container is visible.
		visible: true,
		// .capsule-culture__content are visible.
		page: 1,
		// .team-block__container displays 8 members per page.
		// count: 10,
		prevwidth: 0,
		// .team-block__container is initially NOT filtered.
		category: null,
		// .team-block__container max pages is initially NOT defined.
		maxPages: null,

		filteredList: null,
	
		// Function filteredMembers()...
		filteredMembers() {
			console.log('TEAM: filteredMembers(): '+this.category);

			// Create/populate 'filteredList'.
			// if a filter category is selected, return filtered members for that category...
			// if not, return all members.
			const filteredList = this.category 
			? this.members.filter((item) => {
				return item.category.includes(this.category);
				})
			: this.members;
			// Save filteredList in this.filteredList for use elsewhere.
			this.filteredList = filteredList;
			// 'listLength' = how many members in filteredList?
			const listLength = filteredList.length;
			// Update 'maxPages' = #members / #members per page.
			this.maxPages = Math.ceil(listLength / this.count);
			console.log("TEAM: maxPages: "+this.maxPages);
			console.log("TEAM: pages: "+this.page+" / "+this.maxPages);
			if (this.maxPages == 1) {
				// $('.page-nav').slideUp(200);
				// $('.page-nav').fadeOut(300);
			} else if ($('.page-nav').css('display') == 'none') {
				// $('.page-nav').slideDown(200);
				// $('.page-nav').fadeIn(300);
			}
			// 'start' is index of first member on current page.
			// 'end' is index of last member on current page.
			// Calculate 'start'.
			const start = ((this.page - 1) * this.count);
			// If #members > the index of last member of currently displayed(?) page...
			// (We are not on the last page of filtered members)
			// 'end' is 'start' + #members per page.
			// If not...
			// (We ARE on the last page of filtered members)
			// 'end' is the total #members.
			const end = listLength > start + this.count 
			? start + this.count
			: listLength;

			const wwidth = $(window).width();

			// If this is the last page...
			// Check number of members and hide capsules if necessary.
			if (this.page == this.maxPages) {
				// Get number of members on this page.
				const listLength = this.filteredList.length % this.count;
				console.log("TEAM: members on last page: "+listLength);
				// Get viewport width.
				const wwidth = $(window).width();
				console.log("TEAM: pages: "+this.page+" / "+this.maxPages);
			}

			// Function returns array of members to display on current page.
			this.setGridHeight();
			// this.setGridHeightSimple();
			return filteredList.slice(start, end);
		},

		setChipsPerPage() {
			// Change the value of count so that in different viewport widths/number of columns
			// all rows are full of chips (unless on last page).
			// Triggered on window resize (see .team-grid in markup).
			console.log('TEAM: setChipsPerPage()');

			this.setGridHeight();
			const wwidth = $(window).width();
			if (wwidth < 565) {				// 2 across.
				this.count = 6;
			} else if (wwidth < 1024) {		// 3 across.
				if (this.prevwidth >= 1024 || this.prevwidth < 565) {
					this.count = 6;
				}
			} else if (wwidth < 1320) {		// 4 across.
				if (this.prevwidth >= 1320 || this.prevwidth < 1024) {
					this.count = 8;
				}
			} else if (wwidth >= 1320) {		// 5 across.
				if (this.prevwidth < 1320) {
					this.count = 10;
				}
			}

			if (this.filteredList) {
				this.maxPages = Math.ceil(this.filteredList.length / this.count);
				if (this.page > this.maxPages) {
					this.page = this.maxPages;
				}
			} else {
				this.page = 1;
			}

			this.prevwidth = wwidth;
		},

		setGridHeight() {
			console.log('TEAM: setGridHeight()');

			this.$nextTick(() => {
				// Grab current (old height)
				const oldHeight = this.$refs.grid.style.height;
				// Calculate new height (need to disable transition)
				this.$refs.grid.style.transitionDuration = '0s';
				this.$refs.grid.style.height = 'auto';
				const newHeight = this.$refs.grid.offsetHeight + 'px';
				// Set height to old height, to allow for CSS height transition
				this.$refs.grid.style.height = oldHeight;
				// console.log('TEAM: newHeight: '+newHeight);
				// console.log('TEAM: oldHeight: '+oldHeight);
				setTimeout(() => {
					// Set new height after a beat...
					this.$refs.grid.style.transitionDuration = '500ms';
					this.$refs.grid.style.height = newHeight;
					}, 10);
			});
			// setTimeout(()=> {
			// 	ScrollTrigger.refresh();
			// }, 1000);
		},
		setGridHeightSimple() {
			console.log('TEAM: setGridHeightSimple()');
			const wwidth = $(window).width();
			// 2-column .team-grid.
			if (wwidth < 565) {
				this.$refs.grid.style.height = 'auto';
			// 3-column .team-grid.
			} else if (wwidth < 1024) {
				// this.$refs.grid.style.height = 'fit-content';
				this.$refs.grid.style.height = 'auto';
			} else {
				this.setGridHeight();
			}
			// setTimeout(()=> {
			// 	ScrollTrigger.refresh();
			// }, 300);
		},
		
		// Function setCategory()...
		setCategory(categorySelection) {
			console.log('TEAM: setCategory(): '+categorySelection);
			// A filter has been selected. Update filter category.
			// Display page 1 of newly filtered members.

			$('.page-nav').fadeIn();

			this.category = categorySelection;
			this.page = 1;
			this.fadeIn();
		},

		prev() {
			console.log('TEAM: PREV()');
			if (this.page > 1) {
				this.page--;
				this.fadeIn();
				// setTimeout(()=> {
				// 	ScrollTrigger.refresh();
				// }, 300);
			}
		},
	
		next() {
			console.log('TEAM: NEXT()');
			if (this.page < this.maxPages) {
				this.page++;
				this.fadeIn();
				// setTimeout(()=> {
				// 	ScrollTrigger.refresh();
				// }, 300);
			}
		},
	
		// shuffle(array) { 
		// 	for (let i = array.length - 1; i > 0; i--) { 
		// 	const j = Math.floor(Math.random() * (i + 1)); 
		// 	[array[i], array[j]] = [array[j], array[i]]; 
		// 	} 
		// 	return array; 
		// }
	}));
}

function initSortBy() {
	console.log('TEAM: initSortBy()');
	// On sortby item click, close sortby panel.
	// On sortby item click, set clicked item to active.
	let 
		$my_panel = $('.team-sortby__panel'),
		$my_button = $('.team-sortby__button'),
		$my_sorts = $('.team-sortby__item');

	$my_sorts.on('click', function() {
		$my_sorts.removeClass('active');
		$(this).addClass('active');
		$my_button.removeClass('expanded');
		$my_panel.slideUp(300);
	});
}

exports.init = function () {
	console.log('TEAM: exports.init');
	// Run init methods...

	// initMobileFilter();
	// initDesktopFilter();
	initSortBy();
	document.addEventListener('alpine:init', () => {
		initTeamGrid();
	});
};